import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
// import './global.scss';
import './index.css';
import "leaflet/dist/leaflet.css";
import './styles/base/colors.scss';
import './styles/base/fonts.scss';


ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root"),
);
